import http from "@/jslibs/axios/http";

// 文件上传
export const upload = file => {
    const params = new FormData();
    params.append('file', file);
    const config = {
        "Content-Type": "multipart/form-data;charset=utf-8",
        formData: true,
    };
    return http.post('/common/api/upload', params, config);
}
